module.exports = __webpack_public_path__ + "static/media/stats2.525b0797.png";